import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SmallBoxes() {
  const [isMobile, setIsMobile] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showPlatformSelect, setShowPlatformSelect] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleFavoriteClick = () => {
    setShowAlert(true);
  };

  // 🔥 PLATFORM TESPİT + YÖNLENDİRME
  const redirectToApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // ANDROID
    if (/android/i.test(userAgent)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.vondijital.temelden_app&hl=tr";
      return;
    }

    // IOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href =
        "https://apps.apple.com/tr/app/temelden/id6758143279?l=tr";
      return;
    }

    // WEB → kullanıcıya sor
    setShowPlatformSelect(true);
  };

  const redirectToAndroid = () => {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.vondijital.temelden_app&hl=tr";
  };

  const redirectToIOS = () => {
    window.location.href =
      "https://apps.apple.com/tr/app/temelden/id6758143279?l=tr";
  };

  const closeAlert = () => {
    setShowAlert(false);
    setShowPlatformSelect(false);
  };

  return (
    <div
      style={{
        ...styles.smallBoxesContainer,
        ...(isMobile && styles.mobileSmallBoxesContainer),
      }}
    >
      {/* ALERT */}
      {showAlert && (
        <div style={styles.alertOverlay}>
          <div
            style={{
              ...styles.alertContainer,
              ...(isMobile && styles.mobileAlertContainer),
            }}
          >
            {!showPlatformSelect ? (
              <>
                <h3 style={styles.alertTitle}>Favorilerinize Ulaşın</h3>
                <p style={styles.alertText}>
                  Favori projelerinize daha hızlı erişmek için mobil
                  uygulamamızı kullanabilirsiniz.
                </p>
                <div style={styles.alertButtons}>
                  <button style={styles.cancelButton} onClick={closeAlert}>
                    Vazgeç
                  </button>
                  <button
                    style={styles.redirectButton}
                    onClick={redirectToApp}
                  >
                    Uygulamayı Aç
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 style={styles.alertTitle}>Platform Seçin</h3>
                <p style={styles.alertText}>
                  Hangi platforma yönlendirilmek istiyorsunuz?
                </p>
                <div style={styles.alertButtons}>
                  <button
                    style={styles.cancelButton}
                    onClick={redirectToAndroid}
                  >
                    Android (Google Play)
                  </button>
                  <button
                    style={styles.redirectButton}
                    onClick={redirectToIOS}
                  >
                    iOS (App Store)
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* KUTU 1 */}
      <div
        style={{
          ...styles.smallBox,
          ...(isMobile && styles.mobileSmallBox),
        }}
        onClick={handleFavoriteClick}
      >
        <div
          style={{
            ...styles.imageContainer,
            ...(isMobile && styles.mobileImageContainer),
          }}
        >
          <img
            src="/images/HomePage/SmallBoxes/favorite.png"
            alt="Favorilerim Resmi"
            style={{
              ...styles.image,
              ...(isMobile && styles.mobileImage),
            }}
          />
        </div>
        <div style={styles.textContainer}>
          <h3
            style={{
              ...styles.title,
              ...(isMobile && styles.mobileTitle),
            }}
          >
            Favorilerim
          </h3>
          <p
            style={{
              ...styles.description,
              ...(isMobile && styles.mobileDescription),
            }}
          >
            Favori projelerinize mobil uygulamamızdan kolayca ulaşın!
          </p>
        </div>
      </div>

      {/* KUTU 2 */}
      <div
        style={{
          ...styles.smallBox,
          ...(isMobile && styles.mobileSmallBox),
        }}
        onClick={() => navigate("/sss")}
      >
        <div
          style={{
            ...styles.imageContainer,
            ...(isMobile && styles.mobileImageContainer),
          }}
        >
          <img
            src="/images/HomePage/SmallBoxes/supporticon.png"
            alt="Destek Hattı Resmi"
            style={{
              ...styles.image,
              ...(isMobile && styles.mobileImage),
            }}
          />
        </div>
        <div style={styles.textContainer}>
          <h3
            style={{
              ...styles.title,
              ...(isMobile && styles.mobileTitle),
            }}
          >
            Sıkça Sorulan Sorular
          </h3>
          <p
            style={{
              ...styles.description,
              ...(isMobile && styles.mobileDescription),
            }}
          >
            Platformda merak ettiğiniz tüm bilgilere buradan ulaşabilirsiniz!
          </p>
        </div>
      </div>

      {/* KUTU 3 */}
      <div
        style={{
          ...styles.smallBox,
          ...(isMobile && styles.mobileSmallBox),
        }}
        onClick={() => navigate("/odul_sistemi")}
      >
        <div
          style={{
            ...styles.imageContainer,
            ...(isMobile && styles.mobileImageContainer),
          }}
        >
          <img
            src="/images/HomePage/SmallBoxes/giftchart.png"
            alt="İnşaatta Şans Rüzgarı"
            style={{
              ...styles.image,
              ...(isMobile && styles.mobileImage),
            }}
          />
        </div>
        <div style={styles.textContainer}>
          <h3
            style={{
              ...styles.title,
              ...(isMobile && styles.mobileTitle),
            }}
          >
            İnşaatta Şans Rüzgarı
          </h3>
          <p
            style={{
              ...styles.description,
              ...(isMobile && styles.mobileDescription),
            }}
          >
            Hayalindeki ev seni bekliyor, hem de büyük indirimlerle!
            <br />
            Şans çarkını çevir, sürpriz fırsatları yakala!
          </p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  smallBoxesContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "1300px",
    gap: "30px",
    marginTop: "40px",
    flexWrap: "wrap",
  },
  smallBox: {
    borderRadius: "12px",
    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
    padding: "24px",
    textAlign: "center",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    flex: "1 1 calc(33.333% - 20px)",
    minHeight: "140px",
    backgroundColor: "#f9fafc",
  },
  imageContainer: {
    flex: 1,
    marginRight: "18px",
  },
  image: {
    width: "80%",
    height: "100px",
    objectFit: "cover",
    borderRadius: "10px",
  },
  textContainer: {
    flex: 2,
    textAlign: "left",
  },
  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#3c1e70",
    marginBottom: "8px",
  },
  description: {
    fontSize: "15px",
    color: "#666",
    lineHeight: "1.5",
  },

  alertOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  alertContainer: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "30px",
    width: "450px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
  },
  alertTitle: {
    fontSize: "22px",
    fontWeight: "600",
    color: "#3c1e70",
    marginBottom: "15px",
  },
  alertText: {
    fontSize: "16px",
    color: "#555",
    marginBottom: "25px",
  },
  alertButtons: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
  },
  cancelButton: {
    padding: "12px 25px",
    backgroundColor: "#f0f0f0",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
  redirectButton: {
    padding: "12px 25px",
    backgroundColor: "#3c1e70",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },

  mobileSmallBoxesContainer: {
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    padding: "0 15px",
  },
  mobileSmallBox: {
    width: "90%",
    padding: "16px",
  },
  mobileImageContainer: {
    flex: "0 0 80px",
  },
  mobileImage: {
    height: "80px",
  },
  mobileTitle: {
    fontSize: "18px",
  },
  mobileDescription: {
    fontSize: "14px",
  },
  mobileAlertContainer: {
    width: "90%",
    padding: "20px",
  },
};